export default __webpack_public_path__ + "locales/zh-CN/People.json?hash=10cf4f8fd99d72ec7519e87bb85411a2";